import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectOBNPMappinsQueryItems } from '../../../../redux/obnp-mappings/selector';
import { selectGlobalDBNPRegistrationsListItems } from '../../../../redux/global-dbnp-registrations/selector';
import { selectDbnpListItems } from '../../../../redux/dbnp/selector';
import storePersist from '../../../../redux/storePersist';
import { obnpMappings } from '../../../../redux/obnp-mappings/action';
import { globalDBNPRegistrations } from '../../../../redux/global-dbnp-registrations/action';
import { dbnp } from '../../../../redux/dbnp/action';
import PageLoader from '../../../../components/PageLoader';
import DbnpMappingComponent from '../components/obnp-mapping.component';


const obnpMapping = () => {   
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const dbnpMappingQuery = useSelector(selectOBNPMappinsQueryItems)
  const dbnpItems = useSelector(selectGlobalDBNPRegistrationsListItems)
  const dbnpregistriesItems = useSelector(selectDbnpListItems)
  var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
  console.log(tenantId,'tenantId')
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    selectedDbnpMapping,
    setSelectedDbnpMapping
  ] = useState<any>({})
 

  const fetchDbnpMappingById= ()=>{
    dispatch(obnpMappings.query({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp-mappings/query`,entity:'dbnpMappings',jsonData:{
          
  
      Context:{},
      Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})

  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDbnpMapping({ ...selectedDbnpMapping, [field]: event });
  }

  useEffect(
    () => {
      dispatch(globalDBNPRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations/list`,entity:'globalDBNPRegistrations',jsonData:{
   
                }})).then(()=>{
                  dispatch(dbnp.list({
                    url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/list`,
                    entity: 'dbnp',
                    jsonData: {

              
                  }}))}).then(() => {

            if (parmas?.id > 0) {
                fetchDbnpMappingById()
                setIsLoading(false)
              }else {
                setIsLoading(false)
              }
           
          })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDbnpMapping(dbnpMappingQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(obnpMappings.resetAction({ actionType: 'update' }))
      await dispatch(obnpMappings.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp-mappings`,entity:'dbnpMappings',jsonData:{   
    "Context": {},    
    "Records": [
        selectedDbnpMapping
    ]
}})).then(()=>{
    back()
  })
  

    }else{
      await dispatch(obnpMappings.resetAction({ actionType: 'create' }))
      await dispatch(obnpMappings.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp-mappings`,entity:'dbnpMappings',jsonData:{
          
        "Context": {},    
        "Records": [
            selectedDbnpMapping
        ]
    
  }})).then(()=>{
    back()
  })
  
    }
   
    
  }

const back=()=>{
  navigate('/management/organization/dbn/dbnp-mappings')
} 
// const fetchDbnpList = (dbnpId: any) => {
//     const status = R.find(
//       (item: any) => parseInt(
//         item.Id,
//         10
//       ) === parseInt(
//         dbnpId,
//         10
//       ),
//       dbnpItems?.result?.items
//     )
//     selectedDbnpMapping.IsDBNPConsumerEnabled = status?.IsJoinAsDBNConsumer
//     selectedDbnpMapping.ISDBNPProviderEnabled = status?.IsJoinAsDBNProvider
//     selectedDbnpMapping.IsDBNPSupplierRoleEnabled = status?.IsJoinAsDBNSupplier
//     selectedDbnpMapping.IsDBNPVendorRoleEnabled = status?.IsJoinAsDBNVendor
//     selectedDbnpMapping.IsDBNPPartnerRoleEnabled = status?.IsJoingAsDBNPartner
//   }
    return (
    <>
     {isLoading ? <PageLoader /> : 
          <DbnpMappingComponent 
           id={parmas.id}
           onFormChange={handleInnerFormChange}
           dbnp ={dbnpItems?.result?.items .filter(item => item.TenantId !== tenantId)}
           selectedDbnpMapping={selectedDbnpMapping}
           dbnps={dbnpregistriesItems?.result?.items}
          //  fetchDbnpList={fetchDbnpList}
           back={back}
           handleFormSubmit={handleFormSubmit}
          /> 
        } 
          </>
    )
    
    }
   
    export default obnpMapping;